import React from "react";
import { Check, X, AlertTriangle } from "lucide-react";

interface StatusLabelProps {
  statusCode: number;
  className?: string;
}

export const StatusLabel: React.FC<StatusLabelProps> = ({ statusCode, className = "" }) => {
  const getStatusInfo = (code: number) => {
    switch (code) {
      case 0:
        return {
          text: "通过",
          bgColor: "bg-green-100 dark:bg-green-900/20",
          textColor: "text-green-700 dark:text-green-300",
          icon: <Check className="h-3 w-3" />
        };
      case 2201:
        return {
          text: "BPM",
          bgColor: "bg-yellow-100 dark:bg-yellow-900/20",
          textColor: "text-yellow-700 dark:text-yellow-300",
          icon: <AlertTriangle className="h-3 w-3" />
        };
      default:
        return {
          text: "不通过",
          bgColor: "bg-red-100 dark:bg-red-900/20",
          textColor: "text-red-700 dark:text-red-300",
          icon: <X className="h-3 w-3" />
        };
    }
  };

  const statusInfo = getStatusInfo(statusCode);

  return (
    <div className={`flex items-center space-x-1 px-2 py-1 rounded-full text-xs font-medium ${statusInfo.bgColor} ${statusInfo.textColor} ${className}`}>
      {statusInfo.icon}
      <span>{statusInfo.text}</span>
    </div>
  );
};
